package com.neurobs.ccabserver.transcriptreviewadmin

import com.neurobs.ccab.IdentityData
import com.neurobs.ccabserver.transcriptreviewadmin.components.S3Sync.S3SyncView
import com.neurobs.ccabserver.transcriptreviewadmin.components.TranscriptMetricsView.TranscriptMetricsView
import com.neurobs.ccabserver.transcriptreviewadmin.states.{S3SyncSelectionStateProvider, TranscriptMetricsStateProvider}
import com.neurobs.react.semanticui.UiGridFactory
import org.scalajs.dom
import org.scalajs.dom.raw.Element
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.ReactDOM
import slinky.web.html.div

class Main(targetDiv: Element, userData: IdentityData) {

  ReactDOM.render(
    TranscriptReviewAdmin(userData),
	  targetDiv
  )

}

@react
object TranscriptReviewAdmin {
  case class Props(userData: IdentityData)
  val component = FunctionalComponent[Props] { props =>

    val appHtml = UiGridFactory.Grid(
      S3SyncView(
        UiGridFactory.GridColumn(_)("sixteen wide")
      ),
      TranscriptMetricsView(
        UiGridFactory.GridColumn(_)("sixteen wide")
      )
    )

    S3SyncSelectionStateProvider(
      TranscriptMetricsStateProvider(
        appHtml
      )
    )
  }
}
